import { render } from "./UserPasswordForm.vue?vue&type=template&id=466d5eed"
import script from "./UserPasswordForm.vue?vue&type=script&lang=js"
export * from "./UserPasswordForm.vue?vue&type=script&lang=js"
script.render = render

export default script